import React from "react";
import { useTranslation } from "react-i18next";
import { useRestaurant } from "./RestaurantContext";

// A native <select>, full width of its sidebar/drawer container, rather than
// a custom dropdown or a row of pills - it's the one control that stays
// usable and doesn't need extra layout work whether an admin has 2 locations
// or 20: no wrapping, no scrolling container, keyboard and screen-reader
// support for free. Long restaurant names truncate with an ellipsis instead
// of stretching the sidebar.
const RestaurantSwitcher: React.FC = () => {
  const { t } = useTranslation();
  const { restaurants, currentRestaurantId, selectRestaurant } = useRestaurant();

  // A single restaurant (or none yet) doesn't need a switcher at all - most
  // admins today are in this case, and showing a one-option dropdown would
  // just be noise where the wordmark already is.
  if (restaurants.length < 2) return null;

  return (
    <div className="px-4 py-3 border-b">
      <label htmlFor="restaurant-switcher" className="block text-xs font-medium text-gray-400 uppercase tracking-wide mb-1">
        {t('nav.location')}
      </label>
      <div className="relative">
        <BuildingIcon />
        <select
          id="restaurant-switcher"
          value={currentRestaurantId ?? ""}
          onChange={(e) => selectRestaurant(Number(e.target.value))}
          className="w-full truncate border border-gray-200 rounded-lg py-1.5 pl-7 pr-2 text-sm font-medium text-gray-700 bg-white hover:border-teal-400 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:ring-opacity-50 transition"
        >
          {restaurants.map((r) => (
            <option key={r.id} value={r.id}>
              {r.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

const BuildingIcon: React.FC = () => (
  <svg
    className="w-4 h-4 text-gray-400 absolute left-2 top-1/2 -translate-y-1/2 pointer-events-none"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 21h18M5 21V7l7-4 7 4v14M9 9h1m4 0h1m-6 4h1m4 0h1m-6 4h1m4 0h1" />
  </svg>
);

export default RestaurantSwitcher;
